import {Dispatch, FC, SetStateAction, useEffect} from 'react'
import {Stuffid} from '../../../stuffid-management/stuffids-list/core/_models'
import {StuffidRateCell} from '../../../stuffid-management/stuffids-list/table/columns/StuffidRateCell'
import {useIsOnPremises} from '../../../../auth/core/useOnPremises'

type Props = {
  stuffidInfo: Stuffid
}

const StuffIdInfo: FC<Props> = ({stuffidInfo}) => {
  // The bank's own install has no ID categories (the user, 2026-10-25).
  const onPremises = useIsOnPremises()
  return (
    <>
      <ul style={{listStyle: 'none'}}>
        <li className='text-gray-600'>
          <h3 className='text-info'>{stuffidInfo.cd}</h3>
        </li>
        <li className='text-gray-600'>
          کالا/خدمت: <b className='text-gray-800'>{stuffidInfo.tp}</b>
        </li>
        <li className='text-gray-600'>
          نوع: <b className='text-gray-800 ms-1'>{stuffidInfo.sg}</b>{' '}
        </li>
        {!onPremises && stuffidInfo.cn && (
          <li className='text-gray-600'>
            دسته‌بندی: <b className='text-primary ms-1'>{stuffidInfo.cn}</b>
          </li>
        )}
        <li className='text-gray-600'>
          تاریخ:{' '}
          <b className='text-gray-800' style={{display: 'inline-block'}}>
            {stuffidInfo.dt}
          </b>
        </li>
        <li className='text-gray-600'>
          درصد مالیات بر ارزش افزوده :{' '}
          <b>
            <StuffidRateCell data={stuffidInfo} />
          </b>
        </li>
        <li className='text-gray-600'>
          توضیحات: <b className='text-gray-800'>{stuffidInfo.ds}</b>
        </li>
      </ul>
    </>
  )
}

export {StuffIdInfo}
